module.exports = __webpack_public_path__ + "img/water02.646a7581.png";